import { Candidate, Coalition, Result } from '@/lib/model';
import * as React from 'react';
import './index.scss';

export interface PopupProps {
  x: number;
  y: number;
  offset: number;
  data: Result;
  selectedCandidate: Candidate | null;
}

export const Popup: React.FC<PopupProps> = ({
  data,
  x,
  y,
  offset,
  selectedCandidate,
}) => (
  <div className="Popup" style={{ top: y + offset, left: x + offset }}>
    <div className="Popup__title">
      <span>{data.placeName}</span>
    </div>
    <div className="Popup__bar">
      {data.coalitions.map((coalition, i) => (
        <div
          style={{
            backgroundColor: coalition.fillColor,
            width: `${coalition.percentage}%`,
          }}
          key={i.toString()}
        />
      ))}
    </div>
    <div className="Popup__information">
      <div>
        <span>
          {data.scrutinized.current} di {data.scrutinized.total} sezioni
          scrutinate
        </span>
      </div>
      <div>
        <span>
          {`${data.summary.turnout.label}`}: {`${data.summary.turnout.value}`}
        </span>
        <span>Voti: {`${data.summary.totalVoters.value}`}</span>
      </div>
    </div>
    <div className="Popup__votes">
      <div className="Popup__votes__header">
        {data.showVoti && <span>Voti</span>}
        <span>%</span>
      </div>
      {data.coalitions.map((coalition, i) => {
        if (selectedCandidate) {
          if (coalition.coalitionId !== selectedCandidate.coalitionId) {
            return null;
          }

          if (selectedCandidate.candidateId) {
            coalition = coalition.candidates.find(
              c => c.candidateId === selectedCandidate.candidateId
            ) as Coalition;
          }

          coalition.label = selectedCandidate.label;
        }

        return (
          <div className="Popup__votes__result" key={i.toString()}>
            <div
              className="Popup__votes__result__bar"
              style={{ backgroundColor: coalition.fillColor }}
            />
            <div className="Popup__votes__result__name">{coalition.label}</div>
            <div className="Popup__votes__result__numbers">
              {!(data.is2018 && data.level == 2) && (
                <span>{coalition.votes}</span>
              )}
              <span>{`${coalition.percentage}%`}</span>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);
